'use strict';

exports.__esModule = true;
exports.TabsHeaderContainer = exports.HeaderContainer = exports.HeadersTitles = exports.DoctorName = exports.ExtendedNavLink = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0 16px;\n  ', '\n  ', '\n'], ['\n  padding: 0 16px;\n  ', '\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 0 5px !important;\n  '], ['\n    padding: 0 5px !important;\n  ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n    padding: 0 10px !important;\n  '], ['\n    padding: 0 10px !important;\n  ']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-weight: 500;\n  margin: ', ';\n  display: none;\n  ', '\n'], ['\n  font-weight: 500;\n  margin: ', ';\n  display: none;\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n    display: block;\n  '], ['\n    display: block;\n  ']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-size: 14px !important;\n  ', '\n  ', '\n'], ['\n  font-size: 14px !important;\n  ', '\n  ', '\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n    font-size: 11px !important;\n  '], ['\n    font-size: 11px !important;\n  ']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  background-color: #fff !important;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex !important;\n  grid-area: a;\n  height: 100%;\n  justify-content: space-between;\n  padding: ', ';\n  position: relative;\n'], ['\n  align-items: center;\n  background-color: #fff !important;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex !important;\n  grid-area: a;\n  height: 100%;\n  justify-content: space-between;\n  padding: ', ';\n  position: relative;\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  display: flex;\n  font-size: 18px;\n  height: 100%;\n  padding: 0px 16px;\n  ', '\n  ', '\n'], ['\n  align-items: center;\n  display: flex;\n  font-size: 18px;\n  height: 100%;\n  padding: 0px 16px;\n  ', '\n  ', '\n']),
    _templateObject10 = _taggedTemplateLiteralLoose(['\n    height: 40px; \n  '], ['\n    height: 40px; \n  ']),
    _templateObject11 = _taggedTemplateLiteralLoose(['\n    height: 40px;\n  '], ['\n    height: 40px;\n  ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _webComponents = require('@vezeeta/web-components');

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var ExtendedNavLink = exports.ExtendedNavLink = (0, _styledComponents2.default)(_reactRouterDom.NavLink)(_templateObject, function (props) {
  return props.theme.media.phone(_templateObject2);
}, function (props) {
  return props.theme.media.tablet(_templateObject3);
});

var DoctorName = exports.DoctorName = (0, _styledComponents2.default)(_webComponents.Subheading)(_templateObject4, function (props) {
  return props.language === 'en' ? '0px 12px 0px 0px' : '0px 0px 0px 12px';
}, function (props) {
  return props.theme.media.desktop(_templateObject5);
});

var HeadersTitles = exports.HeadersTitles = (0, _styledComponents2.default)(_webComponents.Subheading)(_templateObject6, function (props) {
  return props.theme.media.phone(_templateObject7);
}, function (props) {
  return props.theme.media.tablet(_templateObject7);
});

var HeaderContainer = exports.HeaderContainer = _styledComponents2.default.header(_templateObject8, function (props) {
  return props.language === 'en' ? '0px 16px 0px 0px' : '0px 0px 0px 16px';
});

var TabsHeaderContainer = exports.TabsHeaderContainer = _styledComponents2.default.div(_templateObject9, function (props) {
  return props.theme.media.phone(_templateObject10);
}, function (props) {
  return props.theme.media.tablet(_templateObject11);
});